<template>
  <div>
    <b-card :title="dataItem.title">
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <div class="text-primary font-weight-bold">
            Teklif Talep Oluşturma Tarihi
          </div>
          <div>
            {{ moment(dataItem.created).format('LL') }}
          </div>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <div class="text-primary font-weight-bold">
            Teklif Talep Numarası
          </div>
          <div>
            #{{ dataItem.onumber }}
          </div>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <div class="text-primary font-weight-bold">
            Başlangıç-Bitiş Tarihleri
          </div>
          <div>
            {{ moment(dataItem.sdate).format('DD.MM.YYYY') }} - {{ moment(dataItem.edate).format('DD.MM.YYYY') }}
          </div>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <div class="text-primary font-weight-bold">
            Durum
          </div>
          <div>
            {{ dataItem.purchase_offer_status }}
          </div>
        </b-col>
        <!--        <b-col-->
        <!--          cols="12"-->
        <!--          md="3"-->
        <!--          class="mt-2"-->
        <!--        >-->
        <!--          <div class="text-primary font-weight-bold">-->
        <!--            Adet-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            {{ dataItem.offer_amount | toNumber }} Adet-->
        <!--          </div>-->
        <!--        </b-col>-->
        <!--        <b-col-->
        <!--          cols="12"-->
        <!--          md="3"-->
        <!--          class="mt-2"-->
        <!--        >-->
        <!--          <div class="text-primary font-weight-bold">-->
        <!--            Belirlenen Tutar-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            {{ dataItem.offer_price |toCurrency }} TL-->
        <!--          </div>-->
        <!--        </b-col>-->
        <b-col
          cols="12"
          md="3"
          class="mt-2"
        >
          <div class="text-primary font-weight-bold">
            Onaylayan
          </div>
          <div>
            {{ dataItem.confirmed_user ? dataItem.confirmed_user : '-' }}
          </div>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mt-2"
        >
          <div class="text-primary font-weight-bold">
            Onay Tarihi
          </div>
          <div>
            {{ dataItem.confirmed ? moment(dataItem.confirmed).format('DD.MM.YYYY') : '-' }}
          </div>
        </b-col>
        <hr>
        <b-col
          cols="12"
          md="12"
          class="mt-3"
        >
          <div class="text-primary font-weight-bold">
            Teklif İçeriği
          </div>
          <div>
            <p v-html="dataItem.content" />
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      title="Durum Güncelle"
      class="mt-2"
    >
      <b-row class="d-flex justify-content-center align-items-center">
        <b-col
          cols="12"
          md="4"
        >
          <purchase-offer-status-select />
        </b-col>
        <b-col
          cols="12"
          md="auto"
        >
          <b-button
            variant="primary"
            :disabled="dataItem.id_confirmed_user !== null || userData.id !== dataItem.id_users"
            @click="callBack"
          >
            <feather-icon icon="SaveIcon" />
            Kaydet
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import PurchaseOfferStatusSelect from '@/views/Admin/Purchase_offers/Elements/View/StatusSelect.vue'

export default {
  name: 'PurchaseOfferViewHeader',
  components: {
    PurchaseOfferStatusSelect,
    BRow,
    BCol,
    BCard,
    BButton,
  },
  props: {
    callBack: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
}
</script>
